"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const typography_1 = require("components/atoms/typography");
const react_1 = __importStar(require("react"));
const reactstrap_1 = require("reactstrap");
class ErrorBoundary extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.state = {
            hasError: false
        };
    }
    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }
    componentDidCatch(error, errorInfo) {
        console.error('Uncaught error:', error, errorInfo);
    }
    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(typography_1.Typography, Object.assign({ typographyType: 'h1' }, { children: 'Oops, There\'s Something error, please check your console.' })), (0, jsx_runtime_1.jsx)(reactstrap_1.Button, Object.assign({ className: 'ml-2', onClick: () => {
                            window.location.href = '/';
                        }, color: 'primary' }, { children: 'Back to Home' }))] }));
        }
        if (this.state.hasError) {
            return (0, jsx_runtime_1.jsx)(typography_1.Typography, Object.assign({ typographyType: 'h1' }, { children: "Sorry.. there was an error" }));
        }
        return ((0, jsx_runtime_1.jsx)(react_1.default.StrictMode, { children: this.props.children }));
    }
}
exports.default = ErrorBoundary;
